import "./Styles.css";

const Spinner = () => <div className="spin" ></div>;

export default Spinner;
